var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNotifyBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_8182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99997 0C6.44685 0 5.99997 0.446875 5.99997 1V1.55938C3.73435 1.91875 1.99997 3.88125 1.99997 6.25V7.29375C1.99997 8.7125 1.5156 10.0906 0.631223 11.1969L0.165598 11.7812C-0.0156524 12.0063 -0.0500274 12.3156 0.0749726 12.575C0.199973 12.8344 0.462473 13 0.749973 13H13.25C13.5375 13 13.8 12.8344 13.925 12.575C14.05 12.3156 14.0156 12.0063 13.8343 11.7812L13.3687 11.2C12.4843 10.0906 12 8.7125 12 7.29375V6.25C12 3.88125 10.2656 1.91875 7.99997 1.55938V1C7.99997 0.446875 7.5531 0 6.99997 0ZM6.99997 3H7.24997C9.04372 3 10.5 4.45625 10.5 6.25V7.29375C10.5 8.79062 10.9343 10.25 11.7406 11.5H2.25935C3.0656 10.25 3.49997 8.79062 3.49997 7.29375V6.25C3.49997 4.45625 4.95622 3 6.74997 3H6.99997ZM8.99997 14H6.99997H4.99997C4.99997 14.5312 5.20935 15.0406 5.58435 15.4156C5.95935 15.7906 6.46872 16 6.99997 16C7.53122 16 8.0406 15.7906 8.4156 15.4156C8.7906 15.0406 8.99997 14.5312 8.99997 14Z",
    fill: "#6B7280"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_8182"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H14V16H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotifyBell);
export default __webpack_public_path__ + "static/media/ic_notify_bell.34a861fa127a3d9ebb9b05c76920aa6a.svg";
export { ForwardRef as ReactComponent };